import { Stack } from '@mui/material';
import { FlowHumanTaskType } from 'flow-schema';

import { type api } from 'common';

import { HumanTaskWorkContextCard } from './Fields/Card';
import { HumanTaskWorkContextHeader } from './Header';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

interface HumanTaskWorkContextProps {
  fieldNamePrefix: string;
  workContextIndex: number;
  onDelete?: () => void;
}

export function HumanTaskWorkContext(props: HumanTaskWorkContextProps) {
  const { workContextIndex, onDelete } = props;
  const { value: taskType } =
    useSelectedNodeField<api.FlowDefinition.HumanTaskBlock['config']['taskType']>(
      'config.taskType'
    );

  return (
    <Stack gap={2}>
      {(taskType === FlowHumanTaskType.CustomSubtask || workContextIndex > 0) && (
        <HumanTaskWorkContextHeader
          headerLabel={`Tab ${workContextIndex + 1}`}
          onDelete={onDelete}
        />
      )}
      <HumanTaskWorkContextCard fieldNamePrefix={props.fieldNamePrefix} />
    </Stack>
  );
}
